export default "__VITE_ASSET__68a08e82__"